import { Prisma } from "db"
import { array } from "fp-ts"

const CategoryIsValidWhere = Prisma.validator<Prisma.CategoryWhereInput>()({
  publishedAt: {
    not: null,
  },
})

const getCategorySelect2 = () =>
  Prisma.validator<Prisma.CategorySelect>()({
    id: true,
    name: true,
    subcategories: {
      orderBy: { name: "asc" },
      select: {
        id: true,
        name: true,
        translations: {
          orderBy: { locale: "asc" },
          select: {
            locale: true,
            name: true,
            namePath: true,
            slug: true,
            slugPath: true,
          },
        },
        updatedAt: true,
      },
      where: CategoryIsValidWhere,
    },
    translations: {
      orderBy: { locale: "asc" },
      select: {
        locale: true,
        name: true,
        namePath: true,
        slug: true,
        slugPath: true,
      },
    },
    updatedAt: true,
  })

const CategoryBySlugPathWhere = (slugPath: Array<string>) =>
  Prisma.validator<Prisma.CategoryWhereInput>()({
    translations: { some: { slugPath: { equals: slugPath } } },
  })

const TopLevelCategoryWhere = Prisma.validator<Prisma.CategoryWhereInput>()({
  parentId: null,
})

export const findCategoriesBySlugPath = (slugPath: Array<string>) => {
  return Prisma.validator<Prisma.CategoryFindManyArgs>()({
    orderBy: { name: "asc" },
    select: getCategorySelect2(),
    where: {
      ...CategoryIsValidWhere,
      ...(array.isNonEmpty(slugPath) ? CategoryBySlugPathWhere(slugPath) : TopLevelCategoryWhere),
    },
  })
}

export const findManyCategories = Prisma.validator<Prisma.CategoryFindManyArgs>()({
  select: {
    translations: {
      orderBy: { locale: "asc" },
      select: { locale: true, name: true, namePath: true, slugPath: true },
    },
    updatedAt: true,
  },
  where: CategoryIsValidWhere,
})

export const findCategoriesPathData = Prisma.validator<Prisma.CategoryFindManyArgs>()({
  select: {
    translations: {
      orderBy: [{ locale: "asc" }],
      select: { locale: true, name: true, namePath: true, slugPath: true },
    },
    updatedAt: true,
  },
  where: CategoryIsValidWhere,
})

export const categoryLocalizedArgs = Prisma.validator<Prisma.CategoryLocalizedFindManyArgs>()({
  select: {
    locale: true,
    slugPath: true,
  },
  where: {
    category: CategoryIsValidWhere,
  },
})
